<template>
  <div class="product-developer-page">
    <!-- 顶部区域：面包屑 + 标签切换 -->
    <div class="page-header">
      <a-breadcrumb>
        <a-breadcrumb-item>产品开发者</a-breadcrumb-item>
        <a-breadcrumb-item>统计清单</a-breadcrumb-item>
      </a-breadcrumb>
      <div class="tab-product-sub">
        <a-radio-group v-model:value="activeTab" @change="handleTabChange">
          <a-radio-button value="product">通过兼容性测评产品</a-radio-button>
          <a-radio-button value="vendor">兼容性测评厂商</a-radio-button>
        </a-radio-group>
      </div>
    </div>

    <!-- 动态渲染组件A/组件B -->
    <div class="content-wrapper">
      <TestProductList v-if="activeTab === 'product'" />
      <TestVendorList v-else />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import TestVendorList from './TestVendorList.vue';
import TestProductList from './TestProductList.vue';

// 标签选中状态：默认选中产品维度
const activeTab = ref('product');

// 标签切换事件
const handleTabChange = (e) => {
  activeTab.value = e?.target?.value || activeTab.value;
  // 切换标签时可重置分页/表格数据（可选）
};
</script>

<style scoped>
.product-developer-page {
  padding: 16px 24px;
  background: #f9fafb;
  min-height: 100vh;
}

/* 顶部头部布局 */
.page-header {
  display: block;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* 单选按钮样式 */
.tab-product-sub :deep(.ant-radio-group) {
  display: inline-flex;
}

/* 内容区 */
.content-wrapper {
  margin-bottom: 24px;
}

.tab-product-sub {
  display: flex;
  justify-content: center;
}
</style>